import { render } from "./MruStatusInstance.vue?vue&type=template&id=73404940&scoped=true"
import script from "./MruStatusInstance.vue?vue&type=script&lang=js"
export * from "./MruStatusInstance.vue?vue&type=script&lang=js"

import "./MruStatusInstance.vue?vue&type=style&index=0&id=73404940&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73404940"]])

export default __exports__